// @flow
import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import StyledFormCheckmark from 'esm-web-pro/components/layout/sidePanel/icons/StyledFormCheckmark';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import { FormClose } from 'grommet-icons';

type Props = {
    point: Object,
    intl: IntlShape,
};

const GisPointsAttributes = (props: Props) => {
    const { point, intl: { formatMessage } } = props;

    const attributes = [
        {
            label: `${formatMessage(attributeMessages.provider)}`,
            value: point.infrastructure_provider.entity.name,
        },
        {
            label: `${formatMessage(attributeMessages.ref)}`,
            value: point.ref,
        },
        {
            label: `${formatMessage(attributeMessages.coordinates)}`,
            value: `${point.gis_point.coordinates.coordinates[1]}, ${point.gis_point.coordinates.coordinates[0]}`,
        },
        {
            label: `${formatMessage(attributeMessages.export)}`,
            value: point.export ? <StyledFormCheckmark /> : <FormClose />,
        },
    ];
    if (point.regions) {
        attributes.push(
            {
                label: `${formatMessage({ id: 'point-region', defaultMessage: 'Region' })}`,
                multiValue: point.regions.map((region) => ({
                    value: region.name,
                    link: region.uuid ? `/infrastructure/map/${point.map}/${point.map_is_active
                        ? 'active' : 'draft'}/layer/region/${
                        region.uuid}` : null,
                })),
                separator: ', ',
            },
        );
    }

    return <Attributes attributes={attributes} />;
};

export default injectIntl(GisPointsAttributes);
